import React from 'react';
import PropTypes from 'prop-types';
import { kebabCase } from 'lodash';
import { Modal, ModalBody, ModalFooter, Button } from 'reactstrap';
import OptionNestedPickerField from './optionNestedPickerField';
const OptionNestedPickerModal = _ref => {
  let allowsMultipleSelection = _ref.allowsMultipleSelection,
    allowsOther = _ref.allowsOther,
    allowsParentSelection = _ref.allowsParentSelection,
    className = _ref.className,
    closeModal = _ref.closeModal,
    isOpen = _ref.isOpen,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? null : _ref$label,
    onChange = _ref.onChange,
    options = _ref.options,
    value = _ref.value;
  return /*#__PURE__*/React.createElement(Modal, {
    className: "t-onpm-".concat(kebabCase(label || 'no-label')),
    isOpen: isOpen
  }, /*#__PURE__*/React.createElement(ModalBody, null, label ? /*#__PURE__*/React.createElement("h2", null, label) : null, /*#__PURE__*/React.createElement(OptionNestedPickerField, {
    allowsMultipleSelection: allowsMultipleSelection,
    allowsOther: allowsOther,
    allowsParentSelection: allowsParentSelection,
    backLabel: label || 'back',
    className: className,
    onChange: onChange,
    options: options,
    value: value
  })), /*#__PURE__*/React.createElement(ModalFooter, null, /*#__PURE__*/React.createElement(Button, {
    className: "t-ts-button-done",
    onClick: closeModal
  }, "Done")));
};
OptionNestedPickerModal.propTypes = {
  label: PropTypes.string,
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  allowsMultipleSelection: PropTypes.bool.isRequired,
  allowsOther: PropTypes.bool.isRequired,
  allowsParentSelection: PropTypes.bool.isRequired,
  className: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({}), PropTypes.array]).isRequired
};
export default OptionNestedPickerModal;